// extracted by mini-css-extract-plugin
export default {"root":"DybProjectCard-module--root--b69e1","flexRow":"DybProjectCard-module--flexRow--f40ed"};